<script lang="ts">
  import type { PageSection } from '$lib/sanity/schemas';
  import SanityGridLayout from '../SanityGridLayout.svelte';
  import PageThemeProvider from '$components/Pages/PageThemeProvider.svelte';
  import { useThemeSpacerMultiplier } from '$components/Pages/PageThemeProvider.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';

  import type { ContentSourceMap, StudioPathLike } from '@sanity/svelte-loader';

  interface Props {
    document: PageSection;
    sourceMap?: ContentSourceMap;
    path?: StudioPathLike;
  }

  let { document, sourceMap, path = [] }: Props = $props();

  let sectionMultiplier = $derived(useThemeSpacerMultiplier(document.theme));
  let rowGaps = $derived(
    toFluidVarInput(64 * sectionMultiplier.mobile, 84 * sectionMultiplier.desktop)
  );
</script>

<PageThemeProvider theme={document.theme ?? {}}>
  <section>
    <div class="container">
      {#if document.layout}
        <SanityGridLayout
          layout={document.layout}
          gridProps={{ rowGaps }}
          {sourceMap}
          path={[...path, 'layout']}
        />
      {/if}
    </div>
  </section>
</PageThemeProvider>

<style>
  section {
    position: relative;
    background-color: var(--theme-general-background-color, none);
  }
</style>
